import DateRangeAction from './DateRangeAction'

export default {
  install( molten ) {
    molten.addPlugin( 'Action', DateRangeAction )
  }
}
